import axiosInstance from '@/utils/api.js'

var state = {
  promisedPayment: []
}

var getters = {
  PROMISED_PAYMENT: (state) => {
    return state.promisedPayment
  }
}

var mutations = {
  SET_PROMISED_PAYMENT: (state, payload) => {
    state.promisedPayment = payload
  }
}

var actions = {
  CREATE_PAYMENT: (context, payload) => {
    return axiosInstance.post('/tariffing/payments', payload)
  },
  CREATE_PROMISED_PAYMENT: (context, payload) => {
    return axiosInstance.post('/tariffing/promised_payments', payload)
  },
  GET_PROMISED_PAYMENT: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/promised_payments?user_id=' + payload.user_id + '&account_id=' + payload.account_id)
    context.commit('SET_PROMISED_PAYMENT', result.data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/payment.js